import { FormInputRow } from '@emerald-works-nova/components'
import { Box, Grid, Switch, Typography } from '@mui/material'
import React from 'react'
import { useTenantFormContext } from '../../tenant-form-context'
import { Controller } from 'react-hook-form'

const USERNAME_LOGIN_FORM_FIELD = 'usernameLogin'

const UsernameLogin = () => {
  const {
    form
  } = useTenantFormContext()

  return (
    <Grid item xs={12}>
      <FormInputRow
        title={
          <Box display='flex' flexDirection='row' alignItems='center' component='span'>
            <Typography component='span'>Username Login</Typography>
            <Controller
              name={USERNAME_LOGIN_FORM_FIELD}
              control={form.control}
              render={(props) => (
                <Switch
                  onChange={(e) => props.field.onChange(e.target.checked)}
                  color='primary'
                  checked={props.field.value}
                />
              )}
            />
          </Box>
        }
        description='Username login allows tenant users to log in with a username and password instead of an email address.'
        smallFormTitles
      />
    </Grid>
  )
}

export default UsernameLogin
